"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _moize = require("moize");
var interop_1 = require("./interop");
var logic_1 = require("./logic");
var rxjs_1 = require("rxjs");
var reselect = require("reselect");
var moizeDefault = interop_1.interopRequireDefault(_moize);
var defaultcreateSelectorRxAsync = createSelectorRxCreator({ deepEquals: false, async: true });
exports.createDeepSelectorRx = createSelectorRxCreator({ deepEquals: true, async: false });
exports.createSelector = reselect.createSelector;
exports.createDeepSelector = reselect.createSelectorCreator(reselect.defaultMemoize, logic_1.deepEquals);
//**********************************
//Termina codigo autogenerado por genselectors.ts
//**********************************
function createSelectorRx() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var func = defaultcreateSelectorRxAsync;
    return func.apply(void 0, __spread(args));
}
exports.createSelectorRx = createSelectorRx;
function createSelectorRxCreator(options) {
    var selectorArr = createSelectorRxAsyncArrCreator(options);
    return function createSelectorRxAsync() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var selectors = args.slice(0, args.length - 1);
        var combiner = args[args.length - 1];
        return selectorArr(selectors, combiner);
    };
}
exports.createSelectorRxCreator = createSelectorRxCreator;
function getSelectorValueClearMemoOnError(valueThunk, clearMemo) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var result;
    try {
        result = valueThunk.apply(void 0, __spread(args));
    }
    catch (error) {
        //Error sincrono;
        clearMemo();
        throw error;
    }
    if (logic_1.isObservable(result)) {
        var r_1 = result;
        //Resultado observable
        return new rxjs_1.Observable(function (subs) {
            var obs = r_1.catch(function (err) {
                clearMemo();
                throw err;
            });
            obs.subscribe(subs);
        });
    }
    else if (logic_1.isPromiseLike(result)) {
        //Resultado promesa
        return result
            .then(function (x) { return x; }, function (error) {
            clearMemo();
            return Promise.reject(error);
        });
    }
    else {
        //Resultado síncrono
        return result;
    }
}
function allSync(x) {
    var anyAsync = logic_1.any(x, function (x) { return logic_1.isObservable(x) || logic_1.isPromiseLike(x); });
    return !anyAsync;
}
function createSelectorRxAsyncArrCreator(options) {
    var moize = moizeDefault({ equals: options.deepEquals ? logic_1.deepEquals : undefined, maxSize: 1 });
    /**Crea un selector con un funcionamiento similar al de reselect.createSelectorRx, pero con la memoización comparando el resultado resuelto de la promesa en lugar de simplemente la promesa*/
    return function createSelectorRxAsyncArr(selectors, combiner) {
        var clearMemos = function () {
            memoCombiner.clear();
            memoAsyncCombiner.clear();
        };
        var memoCombiner = moize(combiner);
        var asyncCombiner = (function () {
            var resultThunk = (function () {
                var asyncS = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    asyncS[_i] = arguments[_i];
                }
                if (allSync(asyncS)) {
                    //Todos los argumentos son SINCRONOS
                    return memoCombiner.apply(void 0, __spread(asyncS));
                }
                else {
                    //Algunos argumentos son OBSERVABLE o PROMISE
                    var argsRx = asyncS.map(function (x) { return logic_1.toObservable(x); });
                    //Observable de los argumentos
                    var argRxLatest = rxjs_1.Observable.combineLatest.apply(rxjs_1.Observable, __spread(argsRx));
                    //Por cada cambio de argumento observamos el resultado del memoCombiner
                    var ret_1 = argRxLatest.map(function (x) {
                        return logic_1.toObservable(memoCombiner.apply(void 0, __spread(x)));
                    }).switch(); //Si llega un nuevo argumento ignoramos los resultados de los observables anteriores con el switch
                    return ret_1;
                }
            });
            return function () {
                var asyncS = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    asyncS[_i] = arguments[_i];
                }
                return getSelectorValueClearMemoOnError.apply(void 0, __spread([resultThunk, clearMemos], asyncS));
            };
        })();
        var memoAsyncCombiner = moize(asyncCombiner);
        var ret = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var myArgs = selectors.map(function (x) { return x.apply(void 0, __spread(args)); });
            return memoAsyncCombiner.apply(void 0, __spread(myArgs));
        };
        return ret;
    };
}
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/keautils/dist/selectors.js
// module id = 2279
// module chunks = 0